import React from 'react';
import CorrugatedCardboardMaterialsSection from 'components/quote_builder_widget/CorrugatedCardboardMaterialsSection';
import { fieldGroupStyle, helpTextStyle, sectionHeaderStyle, toggleContainerStyle } from './sharedStyles';

const CorrugatedMaterialsSectionWrapper = ({
  showCorrugatedCardboardMaterials,
  setShowCorrugatedCardboardMaterials,
  onMaterialsChange,
}) => {
  const dynamicToggleStyle = {
    ...toggleContainerStyle,
    backgroundColor: showCorrugatedCardboardMaterials ? '#d4edda' : '#f8f9fa',
    border: showCorrugatedCardboardMaterials ? '1px solid #c3e6cb' : '1px solid #dee2e6',
  };

  return (
    <div>
      <h4 style={sectionHeaderStyle}>
        {t('quote_builder_widget.section_corrugated_materials')}
      </h4>

      <div style={fieldGroupStyle}>
        <p style={helpTextStyle}>
          {t('quote_builder_widget.corrugated_cardboard_materials_info') || 'Materials available in the widget for corrugated cardboard drawings'}
        </p>

        <div style={dynamicToggleStyle}>
          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
            <input
              type="checkbox"
              checked={showCorrugatedCardboardMaterials}
              onChange={(event) => setShowCorrugatedCardboardMaterials(event.target.checked)}
              style={{ marginRight: '10px', width: '18px', height: '18px' }}
            />
            <span style={{ fontWeight: 500 }}>
              {showCorrugatedCardboardMaterials
                ? (t('quote_builder_widget.corrugated_materials_enabled') || 'Corrugated materials are enabled')
                : (t('quote_builder_widget.corrugated_materials_disabled') || 'Corrugated materials are disabled')}
            </span>
          </label>
        </div>

        {showCorrugatedCardboardMaterials && (
          <CorrugatedCardboardMaterialsSection onMaterialsChange={onMaterialsChange} />
        )}
      </div>
    </div>
  );
};

export default CorrugatedMaterialsSectionWrapper;
